import React, { useState } from "react";
import "./landing.css";
import { useDispatch, useSelector } from "react-redux";
import { logIn, setUser } from "../../features/api/user/userSlice";
import { useLogInMutation } from "../../features/api/user/userApi";
import { CustomToast } from "../../components/common/customToast/CustomToast";
import { useAuth } from "../../customHooks/useAuth";
export const Landing = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useAuth();
  const [userDetails, setUserDetails] = useState({
    userName: "",
    password: "",
  });
  const { isSessionExpired } = useSelector((state) => state.user);

  const [userLogin, { isLoading, isSuccess, isError, error }] =
    useLogInMutation();

  const handleLogin = async (e) => {
    e.preventDefault();
    let { userName, password } = userDetails;
    if (userName && password) {
      try {
        let data = await userLogin(userDetails).unwrap();
        dispatch(setUser(data));
      } catch (err) {
      } finally {
        setUserDetails({
          userName: "",
          password: "",
        });
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  // Decide what to render -
  let content = null;
  if (!isAuthenticated) {
    content = (
      <div className="landingContainer container-fluid">
        {isError && (
          <CustomToast err={isError} msg={error?.data?.errorMessage} />
        )}
        {isSessionExpired && (
          <CustomToast err={true} msg={"Session expired! Please login again"} />
        )}
        <div className="container d-flex align-items-center">
          <div className="row w-100 d-flex g-0 align-items-center">
            {/* Left Side: Heading */}
            <div className="col-xxl-6 col-xl-12 d-flex justify-content-center flex-column text-center text-lg-start">
              <div className="animated-title-box">
                <div className="title">
                  <span className="block"></span>
                  <h1>
                    GroMart Backoffice<span></span>
                  </h1>
                </div>
                <div className="role">
                  <div className="block"></div>
                  <p>BY SUPPLY CORNER</p>
                </div>
              </div>
            </div>

            {/* Right Side: Login Form */}
            <div className="col-xxl-6 col-xl-12 d-flex justify-content-center mt-3">
              <div
                className="card shadow-lg p-4 w-100 animate__animated animate__fadeIn"
                style={{ maxWidth: "500px" }}
              >
                <div className="card-body">
                  <h3 className="text-center mb-4">Login</h3>
                  <form onSubmit={handleLogin}>
                    {/* Email Field */}
                    <div className="mb-3">
                      <label htmlFor="email" className="form-label">
                        Email
                      </label>
                      <input
                        value={userDetails.userName}
                        type="email"
                        id="email"
                        className="form-control"
                        placeholder="Enter your email"
                        minLength={10}
                        maxLength={100}
                        required
                        name="userName"
                        onChange={handleInputChange}
                      />
                    </div>

                    {/* Password Field */}
                    <div className="mb-3">
                      <label htmlFor="password" className="form-label">
                        Password
                      </label>
                      <input
                        value={userDetails.password}
                        type="password"
                        id="password"
                        className="form-control"
                        placeholder="Enter your password"
                        required
                        name="password"
                        onChange={handleInputChange}
                      />
                    </div>

                    {/* Submit Button */}
                    <div className="d-grid">
                      <button type="submit" className="btn btn-primary">
                        Login
                      </button>
                    </div>
                  </form>

                  {/* Forgot Password & Signup Link */}
                  <div className="text-center mt-3">
                    <a href="/reset-password" className="text-decoration-none">
                      Reset Password?
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    content = (
      <div className="landingContainer container-fluid">
        {isError && <CustomToast err={isError} msg={error.data.errorMessage} />}
        <div className="container min-vh-100 d-flex align-items-center">
          <div className="row w-100 d-flex g-0 align-items-center">
            {/* Left Side: Heading */}
            <div className="col-xl-12 d-flex justify-content-center flex-column text-center text-lg-start">
              <div className="animated-title-box">
                <div className="title">
                  <span className="block"></span>
                  <h1>
                    Welcome to GroMart Backoffice<span></span>
                  </h1>
                </div>
                <div className="role">
                  <div className="block"></div>
                  <p>BY SUPPLY CORNER</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return content;
};
